import React from 'react';

const LocationTagIcon: React.FC = () => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 25" fill="none">
      <g
        clipPath="url(#a)"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 10.5c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0Z" />
        <path d="M12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(0 .5)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LocationTagIcon;
